import { traceHistory } from "@/constants/dummy";
import { TabPanel, TabView } from "primereact/tabview";
import React from "react";
import If from "../shared/If";
import { Button } from "primereact/button";
import { useMountEffect, useUpdateEffect } from "primereact/hooks";
import { useNavigate } from "react-router-dom";
import { useContainerWidth } from "@/hooks/useContainerWidth";

export default function TraceabilityHistory({
  item,
  showButton,
}: {
  item: any;
  showButton?: boolean;
}) {
  /***
   *  item: {batch_number, status, product, flow, history}
   *  history: cte, kdes[label, value], assigned_inputer []
   *
   ***/
  const data = item?.history ?? traceHistory;

  // get currently logged in user
  const user = "John Doe";

  const navigate = useNavigate();

  const tabContainerWidth = useContainerWidth("tabcontainer");

  return (
    <div className="flex flex-column align-items-center mx-2" id="tabcontainer">
      <TabView
        className="my-3 border-round"
        style={{
          width: tabContainerWidth - 10,
        }}
      >
        {data.map((item, index) => {
          return (
            <TabPanel
              key={index}
              header={item.cte}
              leftIcon={
                item.assigned_inputer === user ? "pi pi-pencil pr-3" : ""
              }
            >
              <If
                condition={item?.kdes?.length > 0}
                then={
                  <div className="flex flex-column gap-3">
                    {item.kdes.map((kde, index) => {
                      return (
                        <div
                          key={index}
                          className="flex flex-row justify-content-between align-items-center gap-2"
                        >
                          <span className="text-left">{kde.label}</span>
                          <span className="text-right p-tag  bg-primary-100 text-primary-700">
                            {kde.value}
                          </span>
                        </div>
                      );
                    })}

                    <div className="flex flex-column align-items-center gap-3 mt-4">
                      <If
                        condition={user === item.assigned_inputer}
                        then={
                          <Button
                            label="Edit Form Data"
                            className="text-white"
                            onClick={() => {
                              navigate(`/admin/tracking/forms/${Math.random()}`, {
                                state: {
                                  batch_number: data.batch_number,
                                  product: data.product,
                                  cte: item.cte,
                                  status: data.status,
                                  isUpdate: true,
                                },
                              });
                            }}
                          />
                        }
                      />

                      <span>
                        <span className="text-primary-700">Assigned to: </span>
                        {item.assigned_inputer}
                      </span>
                    </div>
                  </div>
                }
                else={
                  <div className="flex flex-column align-items-center gap-3">
                    <span className="text-center my-5">No data available</span>

                    <If
                      condition={user === item.assigned_inputer}
                      then={
                        <Button
                          label="Add Form Data"
                          className="text-white"
                          onClick={() => {
                            navigate(`/admin/tracking/forms/${Math.random()}`, {
                              state: {
                                batch_number: data.batch_number,
                                product: data.product,
                                cte: item.cte,
                                status: data.status,
                              },
                            });
                          }}
                        />
                      }
                    />

                    <span>
                      <span className="text-primary-700">Assigned to: </span>
                      {item.assigned_inputer}
                    </span>
                  </div>
                }
              />
            </TabPanel>
          );
        })}
      </TabView>
    </div>
  );
}
